import { TaskQuery } from '@/gql/graphql';
import { CreateEditTaskFormDefaultValues } from '@/ui/components/createEditTaskSidebar/CreateEditTaskSidebar';
import { encodeAssignedTo } from '@/helpers/taskAssignee';
import { CreateEditTaskFormValues } from '@/ui/components/createEditTaskSidebar/types';

export const buildDefaultValues = (
  task?: TaskQuery['task'],
  defaultValues?: CreateEditTaskFormDefaultValues
): CreateEditTaskFormValues => {
  if (!task) {
    if (defaultValues?.type === 'form') {
      return {
        type: 'form' as const,
        formId: defaultValues.formId,
        templateName: defaultValues.templateName,
        templateDescription: defaultValues.templateDescription,
        assignedTo: defaultValues.assignedTo,
        dueDate: defaultValues.dueDate,
        notes: defaultValues.notes,
      };
    }

    if (defaultValues?.type === 'custom-fields') {
      return {
        type: 'custom-fields' as const,
        customFieldIdentifier: defaultValues.customFieldIdentifier,
        customFieldGroupId: defaultValues.customFieldGroupId,
        templateName: defaultValues.templateName,
        templateDescription: defaultValues.templateDescription,
        assignedTo: defaultValues.assignedTo,
        dueDate: defaultValues.dueDate,
        notes: defaultValues.notes,
      };
    }

    const checklistDefaults =
      defaultValues?.type === 'checklist' ? defaultValues : undefined;
    return {
      type: 'checklist' as const,
      name: checklistDefaults?.name || '',
      checklistItems: checklistDefaults?.checklistItems || [],
      templateName: defaultValues?.templateName,
      templateDescription: defaultValues?.templateDescription,
      assignedTo: defaultValues?.assignedTo,
      dueDate: defaultValues?.dueDate,
      notes: defaultValues?.notes,
    };
  }

  const sharedValues = {
    assignedTo: encodeAssignedTo(task.assignedTo),
    dueDate: task.deadline ? new Date(task.deadline) : undefined,
    notes: task.notes || undefined,
  };

  if (task.__typename === 'ChecklistTask') {
    return {
      ...sharedValues,
      type: 'checklist' as const,
      name: task.name || '',
      checklistItems: task.checklistItems.map((item) => ({
        publicId: item.publicId,
        label: item.name || '',
      })),
    };
  }

  if (task.__typename === 'FormTask' || task.__typename === 'LegacyFormTask') {
    return {
      ...sharedValues,
      type: 'form' as const,
      formId: parseInt(task.formTemplate.id),
    };
  }

  if (task.__typename === 'CustomFieldsTask') {
    return {
      ...sharedValues,
      type: 'custom-fields' as const,
      customFieldIdentifier: task.customFields[0]?.field.identifier,
    };
  }

  return {
    type: 'checklist' as const,
    name: '',
    checklistItems: [],
  };
};
